export enum MICRO_APP_PICKER {
    /**
     * @value Has a user interface
     * @description Title of the Yes/No filter in the micro-app picker that lets the user choose whether to show only micro-apps with a user interface.
     */
    HAS_UI_FILTER = 'MICRO_APP_PICKER.HAS_UI_FILTER',
    /**
     * @value Input variables
     */
    INPUT_VARIABLES = 'MICROAPP.INPUT_VARIABLES',
    /**
     * @value Pre-fill micro-apps field with values. Default value is displayed when not activated.
     */
    INPUT_VARIABLES_DESCRIPTION = 'MICROAPP.INPUT_VARIABLES_DESCRIPTION',
    /**
     * @value Select a micro-app
     * @description Title to display on a micro-apps picker in order to communicate the user that they can select a single micro-app from the given list of micro-apps
     */
    SELECT_MICRO_APP = 'MICRO_APP_PICKER.SELECT_MICRO_APP',
    /**
     * @value Select micro-apps
     * @description Title to display on a micro-apps picker in order to communicate the user that they need to select a micro-app from the given list of micro-apps
     */
    SELECT_MICRO_APPS = 'MICRO_APP_PICKER.SELECT_MICRO_APPS',
    /**
     * @value Setup
     * @description Setup (configuration) of the provider form
     */
    SETUP_MICROAPP = 'CONNECTORS.SETUP',
}
